import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Paragraph } from 'components/atoms/Typography/Typography';
import { Container } from 'components/atoms/Page';
import { FAQItem, SectionHeader } from 'components/molecules';
import markdownToHtml from 'utils/renderMarkdownToHtml';
import './FAQSection.scss';
import faqIcon from '/assets/images/psp/faq.svg';

export function FAQSection({
	className,
	image = faqIcon,
	header = 'Frequently asked questions',
	faqs = [],
	noHeader,
	description,
}) {
	const faqSchema = JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: faqs.map((faq) => ({
			'@type': 'Question',
			name: faq.question,
			acceptedAnswer: {
				'@type': 'Answer',
				text: markdownToHtml(faq.answer),
			},
		})),
	});
	return (
		<div className={classnames(className, 'faqs')}>
			<Container>
				{!noHeader && (
					<SectionHeader
						image={image}
						title={header}
						description={description}
						titleProps={{
							className: 'faq-section-title',
						}}
					/>
				)}

				{!!description && (
					<div className="faq-description">
						<Paragraph>{description}</Paragraph>
					</div>
				)}

				<div className="faq-list">
					<div className="col">
						{faqs.map(({ question, answer, icon }, i) => (
							<FAQItem
								icon={icon}
								question={question}
								answer={answer}
								key={i}
							/>
						))}
					</div>
					{faqSchema && (
						<script
							key="schema"
							type="application/ld+json"
							dangerouslySetInnerHTML={{
								__html: faqSchema,
							}}
						/>
					)}
				</div>
			</Container>
		</div>
	);
}

FAQSection.propTypes = {
	className: PropTypes.string,
	faqSchema: PropTypes.string,
	noHeader: PropTypes.bool,
	image: PropTypes.string,
	header: PropTypes.string,
	hideStorage: PropTypes.bool, // deprecated: no-op, header is now a plain string prop
	description: PropTypes.string,
	faqs: PropTypes.arrayOf(
		PropTypes.shape({
			question: PropTypes.string,
			answer: PropTypes.string,
		})
	),
};

export default FAQSection;
